module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-instruction"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Title"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instruction.title),
      expression: "instruction.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.instruction.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.instruction, "title", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Subtitle"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instruction.subtitle),
      expression: "instruction.subtitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.instruction.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.instruction, "subtitle", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('ActionBar', [_c('div', {
    staticClass: "title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Steps")]), _c('div', {
    staticClass: "action",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": _vm.addStep
    },
    slot: "action"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._l((_vm.instruction.steps), function(step, index) {
    return _c('InstructionStep', {
      key: Math.random(),
      attrs: {
        "step": step
      },
      on: {
        "remove": function($event) {
          return _vm.removeStep(index)
        },
        "resetValue": function($event) {
          return _vm.resetStep(index)
        }
      }
    })
  })], 2)]), _c('div', {
    staticClass: "row columns",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveInstruction
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db787a96!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateInstruction.vue
// module id = 2722
// module chunks = 1